// Components
import createEditorTypeToggledTool from './createEditorTypeToggledComponent';
import HyperlinkRichTextToolContainer from '../richContentTools/HyperlinkRichTextToolContainer';
import TiptapHyperlinkTool from './TiptapHyperlinkTool';

export default createEditorTypeToggledTool(TiptapHyperlinkTool, HyperlinkRichTextToolContainer);
